import Content from "../../help/planning-home.mdx";

export function PlanningHomeHelpPage() {
  return <Content />;
}
